// extracted by mini-css-extract-plugin
export var bounce = "_ov-1";
export var generatingText = "_ov-6";
export var lightning = "_ov-4";
export var popup = "_ov-5";
export var progressBar = "_ov-7";
export var progressFill = "_ov-8";
export var progressShimmer = "_ov-9";
export var progressText = "_ov-a";
export var shimmer = "_ov-3";
export var uploadIcon = "_ov-0";
export var uploadingText = "_ov-2";